<form #mapForm="ngForm" autocomplete="off" [formGroup]="confirmationControl" class="operators-dialog">
  <mat-form-field class="fullWidth">
    <mat-label>Name</mat-label>
    <input matInput required [(ngModel)]="selectedItem.userName" maxlength="255" name="userName" formControlName="userName"
           autocomplete="new-password">
    <mat-error>
      Name is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <div class="password-form-group">
    <mat-form-field class="fullWidth">
      <mat-label>Password</mat-label>
      <input type="password" formControlName="password" required matInput [(ngModel)]="selectedItem.password" name="password"
             pattern="(?=.*[a-zA-Z].*)(?=.*\d.*)\S{8,20}" autocomplete="new-password">
      <mat-error>Invalid password</mat-error>
    </mat-form-field>

    <mat-form-field class="fullWidth">
      <mat-label>Confirm password</mat-label>
      <input type="password" formControlName="confirm-password" matInput required
             [(ngModel)]="selectedItem.passwordConfirm" name="confirm-password"  autocomplete="new-password"
             [errorStateMatcher]="matcher">
      <mat-error *ngIf="confirmationControl.errors?.mismatch">Confirm password does not match Password</mat-error>
    </mat-form-field>
  </div>

  <ac-input-container label="Security Policies" [required]="true" [customError]="securityPolicyError" (focusout)="securityPolicyFocusout()">
    <ac-select [(acModel)]="selectedItem.securityPolicyIds" (acModelChange)="updateSubmitButtonState()"
               [multiple]="true" [bindValue]="'id'" [bindLabel]="'name'" [allowClear]="true"
               [items]="securityPolicyOptions">
    </ac-select>
  </ac-input-container>

  <mat-form-field class="fullWidth"  *ngIf="isLoginSecureEnable">
    <mat-label>Operator Status</mat-label>
    <mat-select [(ngModel)]="selectedItem.status" name="status" formControlName="status" required>
      <mat-option *ngFor="let item of lockStatusOptions" [value]="item.value" >
        {{item.text}}
      </mat-option>
    </mat-select>
    <mat-error>
      Operator Status is <strong>required</strong>
    </mat-error>
  </mat-form-field>


  <div class="password-rules-container">
    <span class="password-rule-item">The password length must be between 8 and 20.</span>
    <span class="password-rule-item">Must contain at least one letter and one digit.</span>
  </div>
</form>

